import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/media/icons/duotone/Code/Code.svg'
import _imports_1 from '@/assets/media/icons/duotone/General/Shield-protected.svg'
import _imports_2 from '@/assets/media/icons/duotone/Home/Home2.svg'
import _imports_3 from '@/assets/media/icons/duotone/Communication/Call.svg'
import _imports_4 from '@/assets/media/icons/duotone/Communication/Mail-at.svg'
import _imports_5 from '@/assets/media/icons/duotone/General/Attachment2.svg'
import _imports_6 from '@/assets/media/icons/duotone/General/Fire.svg'


const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Institution")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm" }
const _hoisted_6 = { class: "d-flex align-items-center mb-5" }
const _hoisted_7 = { class: "symbol symbol-50px me-5" }
const _hoisted_8 = { class: "bg-light-success symbol-label" }
const _hoisted_9 = { class: "svg-icon-success svg-icon svg-icon-2x" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Institution Code", -1)
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { class: "d-flex align-items-center mb-5" }
const _hoisted_15 = { class: "symbol symbol-50px me-5" }
const _hoisted_16 = { class: "bg-light-primary symbol-label" }
const _hoisted_17 = { class: "svg-icon-primary svg-icon svg-icon-2x" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Institution Name", -1)
const _hoisted_21 = { class: "col-sm" }
const _hoisted_22 = { class: "d-flex align-items-center mb-5" }
const _hoisted_23 = { class: "symbol symbol-50px me-5" }
const _hoisted_24 = { class: "bg-light-dark symbol-label" }
const _hoisted_25 = { class: "svg-icon-dark svg-icon svg-icon-2x" }
const _hoisted_26 = { class: "d-flex flex-column" }
const _hoisted_27 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Institution Address", -1)
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "d-flex align-items-center mb-5" }
const _hoisted_31 = { class: "symbol symbol-50px me-5" }
const _hoisted_32 = { class: "bg-light-danger symbol-label" }
const _hoisted_33 = { class: "svg-icon-danger svg-icon svg-icon-2x" }
const _hoisted_34 = { class: "d-flex flex-column" }
const _hoisted_35 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Institution Phone", -1)
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = { class: "d-flex align-items-center mb-5" }
const _hoisted_40 = { class: "symbol symbol-50px me-5" }
const _hoisted_41 = { class: "bg-light-warning symbol-label" }
const _hoisted_42 = { class: "svg-icon-warning svg-icon svg-icon-2x" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Institution Email", -1)
const _hoisted_46 = { class: "col-sm" }
const _hoisted_47 = { class: "d-flex align-items-center mb-5" }
const _hoisted_48 = { class: "symbol symbol-50px me-5" }
const _hoisted_49 = { class: "bg-light-info symbol-label" }
const _hoisted_50 = { class: "svg-icon-info svg-icon svg-icon-2x" }
const _hoisted_51 = { class: "d-flex flex-column" }
const _hoisted_52 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Gateway", -1)
const _hoisted_54 = { class: "col-sm" }
const _hoisted_55 = { class: "d-flex align-items-center mb-5" }
const _hoisted_56 = { class: "symbol symbol-50px me-5" }
const _hoisted_57 = { class: "bg-light-gray-600 symbol-label" }
const _hoisted_58 = { class: "svg-icon-warning svg-icon svg-icon-2x" }
const _hoisted_59 = { class: "d-flex flex-column" }
const _hoisted_60 = { class: "text-dark fs-6 fw-bolder" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "text-muted fw-bold" }, "Status", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "col-sm" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mb-5" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("section", null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, [
                  _createVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: _imports_0 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.data?.data.institution &&
                      _ctx.data?.data.institution.code ? _ctx.data?.data.institution.code.toUpperCase() : '-'), 1),
                _hoisted_12
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("span", _hoisted_16, [
                  _createVNode("span", _hoisted_17, [
                    _createVNode(_component_inline_svg, { src: _imports_1 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.data?.data.institution &&
                    _ctx.data?.data.institution.name ? _ctx.data?.data.institution.name : '-'), 1),
                _hoisted_20
              ])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("span", _hoisted_24, [
                  _createVNode("span", _hoisted_25, [
                    _createVNode(_component_inline_svg, { src: _imports_2 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("span", _hoisted_27, _toDisplayString(_ctx.data?.data.institution &&
                    _ctx.data?.data.institution.address ? _ctx.data?.data.institution.address : '-'), 1),
                _hoisted_28
              ])
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode("span", _hoisted_32, [
                  _createVNode("span", _hoisted_33, [
                    _createVNode(_component_inline_svg, { src: _imports_3 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("span", _hoisted_35, _toDisplayString(_ctx.data?.data.institution &&
                    _ctx.data?.data.institution.phone ? _ctx.data?.data.institution.phone : '-'), 1),
                _hoisted_36
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("span", _hoisted_41, [
                  _createVNode("span", _hoisted_42, [
                    _createVNode(_component_inline_svg, { src: _imports_4 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("span", _hoisted_44, _toDisplayString(_ctx.data?.data.institution &&
                    _ctx.data?.data.institution.email ? _ctx.data?.data.institution.email : '-'), 1),
                _hoisted_45
              ])
            ])
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("span", _hoisted_49, [
                  _createVNode("span", _hoisted_50, [
                    _createVNode(_component_inline_svg, { src: _imports_5 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_51, [
                _createVNode("span", _hoisted_52, _toDisplayString(_ctx.data?.data.gateway ? _ctx.data?.data.gateway : '-'), 1),
                _hoisted_53
              ])
            ])
          ]),
          _createVNode("div", _hoisted_54, [
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _createVNode("span", _hoisted_57, [
                  _createVNode("span", _hoisted_58, [
                    _createVNode(_component_inline_svg, { src: _imports_6 })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_59, [
                _createVNode("span", _hoisted_60, _toDisplayString(_ctx.data?.data.institution &&
                    _ctx.data?.data.institution.is_active ? 'ACTIVE' : '-'), 1),
                _hoisted_61
              ])
            ])
          ]),
          _hoisted_62
        ])
      ])
    ], 512), [
      [_directive_loading, !_ctx.data]
    ])
  ]))
}